var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledAlertExclamationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF5C4A"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.91 23.874c0 1.057-.856 1.915-1.91 1.915-1.054 0-1.91-.858-1.91-1.915V16.21c0-1.058.856-1.916 1.91-1.916 1.054 0 1.91.858 1.91 1.916v7.663zM21 31.537c-1.054 0-1.91-.858-1.91-1.916 0-1.057.856-1.916 1.91-1.916 1.054 0 1.91.859 1.91 1.916 0 1.058-.856 1.916-1.91 1.916zm20.163-1.335L26.516 5.835C25.372 3.935 23.31 2.8 21 2.8s-4.372 1.134-5.516 3.035L.837 30.202C-.248 32.008-.28 34.18.75 36.012 1.856 37.98 4.004 39.2 6.353 39.2h29.294c2.349 0 4.497-1.22 5.602-3.188 1.031-1.831.999-4.004-.086-5.81z",
    transform: "translate(-42 -656) translate(-196 472) translate(238 184)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledAlertExclamationRed);
export default __webpack_public_path__ + "static/media/icon-filled-alert-exclamation-red.c2156f41e138b8d8cb7ffe2bb4506d25.svg";
export { ForwardRef as ReactComponent };